module.exports = new __parcel__URL__("add-to-list.97836d60.png").toString();